import React from "react"

const generalErrorMessage = <>Maaf, kami tidak dapat meneruskan permintaan anda secara dalam talian.
  Sila hubungi Khidmat Pelanggan kami di <a href="tel:1800889933">1 800 889 933</a> atau <a href="tel:+60321707300">+603 2170 7300</a>,
  waktu operasi 8.30 pagi - 5.00 petang (Isnin hingga Jumaat) tidak termasuk cuti umum. Anda juga boleh menghantar butiran kenderaan anda
  (plat nombor dan No. KP) melalui e-mel ke <a href="mailto:customer@bsompo.com.my">customer@bsompo.com.my</a> untuk mendapat bantuan lanjut.</>

export default {
  id: "BM",
  homeLinks: {
    home: "https://online.berjayasompo.com.my/securemotor/",
    en: "https://online.berjayasompo.com.my/securemotor/",
    bm: "https://online.berjayasompo.com.my/securemotor/insurans-kereta/",
    // home: "https://traveluat.berjayasompo.com.my/securemotor/",
    // en: "https://traveluat.berjayasompo.com.my/securemotor/",
    // bm: "https://traveluat.berjayasompo.com.my/securemotor/insurans-kereta/",
    partner: "https://travel.berjayasompo.com.my/travel-insurance/highlights/partner.html",
  },
  head: {
    title: "CIMB Secure Motor Insurans",
    description: "Kami menawarkan pelan insurans kereta yang komprehensif dan berpatutan. Nikmati pelan ansuran 0% tanpa faedah dengan kad kredit CIMB.  Dapatkan sebut harga segera dan perbaharui dalam talian."
  },
  header: {
    url: '/insurans-kereta/',
    home: "Laman Utama",
    how_to_claim: "Cara Menuntut",
    authorised_panel_workshops: "Bengkel Panel",
    esi_motor_claims: "ESi-Motor Claims",
    contact_us: "Hubungi Kami",
    partner_with_us: "Berkerjasama Dengan Kami",
    online_products: "Produk Dalam Talian"
  },
  breadnav: {
    step1: "Langkah 1",
    step2: "Langkah 2",
    step3: "Langkah 3",
    plan: "Pelan",
    details: "Butiran",
    payment: "Bayaran",
  },
  docs: {
    sc_pds: "/securemotor/docs/Secure Motor PDS BM Latest.pdf",
    sc_pw: "/securemotor/docs/Secure Motor PW BM Latest.pdf",
    sc_tnc: "/securemotor/docs/Terms Conditions for 612 Months IPP for Secure Motor Insurance (BM).pdf",
    sc_tnc_medical: "/securemotor/docs/complimentary-medical-benefits-campaign-secure-motor-insurance-tnc-bm.pdf",
    sc_rakan: "/securemotor/docs/Rakan_Auto.pdf",
  },
  planPage: {
    viewAll: "Lihat semua faedah",
    buyNow: "Beli sekarang",
    emailQuote: "E-mel Sebut Harga",
    editQuote: "Edit Sebut Harga",
    enterEmail: "Sila masukkan alamat e-mel di bawah untuk mendapatkan sebut harga anda",
    byClickSend_1: "Dengan mengklik butang 'Hantar e-mel', anda telah membaca dan bersetuju untuk menerima",
    byClickSend_2: "Notis Privasi",
    byClickSend_3: "kami",
    sendEmail: "Hantar e-mel",
    quoteSent: "Sebut harga anda telah dihantar ke e-mel yang diberikan.",
    quoteError: "Penghantaran e-mel gagal ketika cuba menghantar sebut harga anda!",
    to: "sehingga",
    close: "tutup",
    windscreenDamage: "Cermin Depan kerosakan",
    gasConversion: "Kit Pertukaran dan Tangki Gas",
    gasConversionRM200MinSumInsured: "Jumlah Diinsuranskan Minimum ialah RM200",
    gasConversionMsg: "Menyediakan perlindungan untuk kehilangan atau kerosakan pada Kit Pertukaran Gas dan Tangki kenderaan.",
    LOUP: "Pampasan Kehilangan Penggunaan Kenderaan - E-ride/ Hailing (bayaran balik)",
    LOUPMsg: "Perlindungan untuk yuran yang ditanggung dengan menggunakan perkhidmatan e-ride/hailing semasa kereta anda sedang dibaiki oleh bengkel yang kami luluskan.",
    ALP: "Perlindungan Pinjaman Kenderaan",
    ALPMsg: "Menyediakan perlindungan untuk mengurangkan atau menyelesaikan pinjaman sewa beli kenderaan yang tertunggak sekiranya pemegang polisi kematian akibat daripada kemalangan.",
    addOnWindscreen: "Perlindungan Cermin Depan",
    enhancedWindscreen: "Perlindungan Cermin Depan",
    addOnWindscreenDesc: "Memberi perlindungan terhadap kerosakan pada cermin depan, tingkap dan bumbung matahari kereta anda. Sertakan perlindungan ini untuk mengelakkan tuntutan cermin depan daripada menjejaskan NCD anda.",
    rm200MinSumInsured: "Jumlah Diinsuranskan Minimum ialah RM200",
    addOnTowing: "Kos Tunda Tanpa Had",
    addOnTowingDesc: "Perkhidmatan tunda tanpa had di mana-mana sahaja di Malaysia sepanjang tempoh polisi anda.",
    addOnPersonalAccident: "Kemalangan Diri",
    addOnPersonalAccidentDesc: "Melindungi semua penumpang & pemandu sekiranya berlaku kecederaan anggota badan, hilang upaya atau kematian yang disebabkan oleh kemalangan.",
    noVoluntaryExcess: "Tiada Lebihan Sukarela",
    noVoluntaryExcessDesc: "Tiada lebihan sukarela yang perlu ditanggung sendiri untuk setiap tuntutan yang diluluskan, walaupun kemalangan tersebut bukan disebabkan oleh anda. Namun demikian, premium tahunan yang perlu ditanggung adalah lebih tinggi.",
    voluntaryExcess: "Belian 3% untuk Lebihan Sukarela",
    voluntaryExcessDesc: "Lebihan sukarela ialah jumlah yang perlu dibayar oleh anda terlebih dahulu jika anda membuat tuntutan. Jika anda bersetuju untuk membayar lebihan sukarela, anda akan membayar premium tahunan yang lebih rendah.",
    thirdPartyFireTheft: "Pihak Ketiga, Kebakaran & Kecurian",
    additionalCoverage: "Perlindungan Tambahan",
    addOnBenefit: "Lengkapkan perlindungan anda dengan manfaat tambahan pilihan:",
    liabilityOfPassenger: "Liabiliti Undang-undang Penumpang",
    liabilityOfPassengerDesc: "Melindungi anda daripada liabiliti undang-undang penumpang anda untuk tindakan kecuaian.",
    ncdRelief: "Pampasan NCD Tahun Semasa ",
    ncdReliefDesc: "Perlindungan ke atas kelayakan Diskaun Tanpa Tuntutan (NCD) tahun semasa anda. Apabila tuntutan dibuat, ia akan memberi pampasan jumlah NCD yang anda layak dalam tempoh semasa insurans.",
    betterment: "Penepian Penambahbaikan",
    bettermentDesc: "Meliputi penggantian bahagian kenderaan anda yang rosak dengan alat ganti baharu tanpa sebarang kos tambahan.",
    vehAccessories: "Aksesori Kenderaan",
    vehAccessoriesDesc: "Pampasan untuk kerosakan atau kehilangan aksesori kenderaan anda. Contohnya: sistem stereo, rim sukan & banyak lagi.",
    strikeRiotCivil: "Mogok, Rusuhan dan Kekecohan Awam",
    strikeRiotCivilDesc: "Perlindungan tambahan ini melindungi anda daripada kerugian atau kerosakan pada kenderaan anda akibat mogok, rusuhan atau kekecohan awam.",
    IncPerils: "Peril Khas (Bencana Khas)",
    IncPerilsDesc: "Melindungi kenderaan anda daripada kerosakan akibat banjir, ribut dan bencana alam lain.",
    addOnCart: "Pampasan Untuk Taksiran Tempoh Pembaikan (CART)",
    addOnCartDesc: "Pampasan untuk kehilangan penggunaan kenderaan anda berdasarkan anggaran masa pembaikan yang dinilai oleh Adjuster",
    rm50maxPer7days: "RM50 Sehari Sehingga Maksimum 7 Hari",
    rm100maxPer7days: "RM100 Sehari Sehingga Maksimum 7 Hari",
    rm200maxPer7days: "RM200 Sehari Sehingga Maksimum 7 Hari",
    rm50maxPer14days: "RM50 Sehari Sehingga Maksimum 14 Hari",
    rm100maxPer14days: "RM100 Sehari Sehingga Maksimum 14 Hari",
    rm200maxPer14days: "RM200 Sehari Sehingga Maksimum 14 Hari",
    rm50maxPer21days: "RM50 Sehari Sehingga Maksimum 21 Hari",
    rm100maxPer21days: "RM100 Sehari Sehingga Maksimum 21 Hari",
    rm200maxPer21days: "RM200 Sehari Sehingga Maksimum 21 Hari",
    liabilityToPassenger: "Liabiliti Undang-undang Kepada Penumpang",
    liabilityToPassengerDesc: "Melindungi anda daripada liabiliti undang-undang yang diminta oleh penumpang anda terhadap anda sekiranya berlaku kemalangan akibat kecuaian anda. Manfaat ini diwajibkan jika anda memandu di Singapura.",
    addOnNatureCover: "Tambah Nilai Untuk Perlindungan Bencana Alam Penuh",
    addOnNatureCoverDesc: "Melindungi kenderaan anda daripada kerosakan yang disebabkan oleh banjir, ribut dan bencana alam yang lain.",
    cartDays: "Hari CART",
    cart: "Pampasan Untuk Taksiran Tempoh Pembaikan",
    addOnEhailing: "E-Hailing",
    addOnEhailingDesc: "Melindungi kenderaan anda daripada kerosakan, liabiliti kepada penumpang yang membayar tambang dan pihak ketiga semasa memberi perkhidmatan e-hailing.",
    showAllAddOns: "Tunjukkan Semua Perlindungan Tambahan",
    hideAddOns: "Sorokkan Perlindungan Tambahan",
    LLTP: "Liabiliti Undang-undang terhadap Pembonceng",
    specialPerils: "Peril Khas (Bencana Khas)",
    strikeRiot: "Mogok, Rusuhan dan Kekecohan Awam",
    refreshQuote: "Muat Semula Sebut Harga",
    updateQuote: "Kemaskini Sebut Harga",
    quotationSummary: "Ringkasan Sebut Harga",
    sumInsured: "Jumlah Diinsuranskan",
    basicPremium: "Premium Asas",
    marketValue: "Nilai Pasaran",
    agreedValue: "Nilai Dipersetujui",
    excessFee: "Yuran Lebihan",
    allRiders: "Semua Rider",
    loading: "Beban (Loading)",
    ncd: "Diskaun Tanpa Tuntutan (NCD)",
    totalBasePremium: "Jumlah Premium Asas",
    addOns: "Tambahan",
    totalAddOns: "Jumlah Tambahan",
    grossPremium: "Premium Kasar",
    rebate: "Rebat",
    sst: "Cukai Perkhidmatan",
    stampDuty: "Duti Setem",
    totalPremium: "Jumlah Premium",
    commission_disclaimer: "Termasuk 10% komisen kepada pengantara insurans",
    quotationDesc: "Sila baca Lembaran Pendedahan Produk atau Polisi untuk polisi pembatalan dan bayaran balik.",
    vehicleDetails: "Butiran Kenderaan",
    pleaseFillInYourDetailsBelow: "Sila isikan butiran anda di bawah",
    vehicleRegistrationNo: "No. Pendaftaran Kenderaan",
    yearOfMake: "Tahun Buatan",
    chassisNo: "No. Casis",
    engineNo: "No. Enjin",
    vehicleMake: "Buatan Kenderaan",
    vehicleModel: "Model Kenderaan",
    variant: "Varian",
    carUnderFinancing: "Kereta Di Bawah Pembiayaan",
    hirePurchase: "Sewa Beli",
    employeeLoan: "Pinjaman Kakitangan",
    leasing: "Pemajakan",
    loanCompany: "Syarikat Pinjaman",
    periodOfInsurance: "Tempoh Insurans",
    start: "Mula",
    end: "Tamat",
    selectYourPlan: "Pilih Pelan Anda",
    pleaseSelectYourPreferredPlan: "Sila pilih pelan pilihan anda",
    basisSumInsured: "Penilaian Kereta",
    recommended: "Dicadangkan",
    comprehensive: "Komprehensif ",
    thirdParty: "Pihak Ketiga",
    premiumPayable: "Premium Perlu Dibayar",
    select: "Pilih",
    selected: "Dipilih",
    recommendedSumInsured: "Cadangan Jumlah yang Diinsuranskan",
    additionalCoverage: "Perlindungan Tambahan",
    completeYourCover: "Lengkapkan perlindungan anda dengan manfaat tambahan pilihan:",
    planA: "Pelan A",
    planB: "Pelan B",
    planC: "Pelan C",
    planPa1: "RM25,000/setiap orang",
    planPa2: "RM50,000/setiap orang",
    planPa3: "RM100,000/setiap orang",
    planAfull: "Pelan A - 25,000",
    planBfull: "Pelan B - 50,000",
    planCfull: "Pelan C - 100,000",
    showAllAddOns: "Tunjukkan Semua Perlindungan Tambahan",
    hideAddOns: "Sorokkan Perlindungan Tambahan",
    LLTP: "Liabiliti Undang-undang terhadap Pembonceng",
    specialPerils: "Peril Khas (Bencana Khas)",
    strikeRiot: "Mogok, Rusuhan dan Kekecohan Awam",
    refreshQuote: "Muat Semula Sebut Harga",
    updateQuote: "Kemaskini Sebut Harga",
    back: "Kembali",
    next: "Seterusnya",
    quotationSummary: "Ringkasan Sebut Harga",
    sumInsured: "Jumlah Diinsuranskan",
    basicPremium: "Premium Asas",
    planLoupAfull: "Pelan A - 500",
    planLoupBfull: "Pelan B - 1,000",
    planLoupCfull: "Pelan C - 3,000",
    cartDays: "Hari CART",
    bundleAddOn: "Pakej Tambahan: Motor N-Hancer Pack / Enhancer Pack",
    bundleAddOnMsg: "Tambahan bundle yang ditawarkan kepada kenderaan berumur antara 5 hingga 14 tahun di mana premiumnya lebih murah berbanding dengan membeli setiap add-on secara individu. Alat tambah individu tidak lagi dibenarkan untuk dipilih jika anda memilih alat tambah himpunan ini.",
    bundlePA: "Kemalangan Diri - Pelan A (Jumlah Diinsuranskan RM25,000)",
    bundleKey: "Penggantian Kunci - sehingga RM1,000",
  },
  detailPlan: {
    quotationDesc: "Pelanggan mempunyai pilihan untuk mengambil pelan ansuran pada kadar faedah 0% selama 6 bulan atau 12 bulan untuk kad kredit yang dikeluarkan oleh CIMB Bank dengan pembayaran minimum RM480.",
    policyholderDetails: "Butiran Pemegang Polisi",
    policyholderDesc: "Sila isikan butiran anda di bawah",
    fullName: "Nama Penuh (Seperti dalam KP)",
    nationality: "Kewarganegaraan",
    nricPassport: "No. KP / Pasport",
    dob: "Tarikh Lahir",
    gender: "Jantina",
    male: "Lelaki",
    female: "Perempuan",
    mobileNo: "No. Telefon Bimbit (010xxxxxxx)",
    sstNo: "No. SST ",
    email: "E-mel",
    mailingAddress: "Alamat Surat-menyurat",
    address: "Alamat",
    postcode: "Poskod",
    city: "Bandar",
    addState: "Negeri",
    companyname: "Nama Syarikat",
    field_require: "Sila Isi Ruang Yang Berkenaan",
    busregno: "Nombor Pendaftaran Perniagaan",
    insuredMobileNoError: "Sila masukkan nombor telefon bimbit yang sah",
    insuredSSTError: "Sila masukkan nombor SST yang sah",
    addressLine1: "Alamat 1",
    addressLine2: "Alamat 2",
    addressLine3: "Alamat 3",
    invalid_postcode: "Poskod tidak sah",
  },
  summaryPlan: {
    fullName: "Nama Penuh (Seperti dalam KP)",
    companyname: "Nama Syarikat",
    summaryNPayment: "Ringkasan & Pembayaran",
    summaryDesc: "Sila semak dan sahkan maklumat di bawah",
    quotationDetails: "Butiran Sebut Harga",
    coverageFrom: "Perlindungan daripada ",
    coverageTo: " Hingga ",
    coverageType: "Jenis Perlindungan",
    mainInsuredDetails: "Butiran Individu Utama Diinsuranskan",
    periodOfInsurance: "Tempoh Insurans",
    excess: "Yuran Lebihan",
    vehicleDetails: "Butiran Kenderaan",
    carRegNo: "Nombor Pendaftaran Kenderaan",
    makeModel: "Buatan/Model",
    variantSeries: "Siri Varian",
    seatingCapacity: "Kapasiti Tempat Duduk",
    engineCapacity: "Kapasiti Enjin",
    yearOfMake: "Tahun Buatan",
    chassisNo: "No. Casis",
    engineNo: "No. Enjin",
    namedDriver: "Pemandu yang Dinamakan",
    anyDriver: "Mana-mana Pemandu Yang Dibenarkan",
    enterPromoCode: "Masukkan Kod Promosi",
    havePromoCode: "Adakah anda mempunyai kod promosi?",
    promoCodeApplied: "Kod promosi telah dikenakan.",
    apply: "Mohon",
    invalidPromoCode: "Kod Promosi tidak sah!",
    field_require: "Sila Isi Ruang Yang Berkenaan",
    payNow: "Bayar Sekarang",
    back: "Kembali",
    pleaseSelectPaymentMethod: "Sila pilih kaedah pembayaran anda",
    fullName: "Nama Penuh (Seperti dalam KP)",
    nationality: "Kewarganegaraan",
    nricPassport: "No. KP / Pasport",
    dob: "Tarikh Lahir",
    gender: "Jantina",
    male: "Lelaki",
    female: "Perempuan",
    mobileNo: "No. Telefon Bimbit (010xxxxxxx)",
    email: "E-mel",
    mailingAddress: "Alamat Surat-menyurat",
    address: "Alamat",
    postcode: "Poskod",
    city: "Bandar",
    busRegNo: "Nombor Pendaftaran Perniagaan",
    typeOfBusiness: "Jenis Perniagaan",
    occupation: "Pekerjaan",
    pymt_01: "KREDIT / DEBIT / FPX",
    pymt_02: "KAD KREDIT CIMB PELAN BAYARAN ANSURAN 6 BULAN (KONVENSIONAL KAD KREDIT SAHAJA)",
    pymt_03: "KAD KREDIT CIMB PELAN BAYARAN ANSURAN 12 BULAN (KONVENSIONAL KAD KREDIT SAHAJA)",
    before_finalizing: "Sebelum memuktamadkan pembelian, saya mengakui bahawa CIMB Bank Berhad akan menerima komisen untuk menyediakan perkhidmatan berkaitan insurans. Saya juga memahami bahawa produk serupa bersama rebat penuh ke atas komisen boleh dibeli terus daripada Berjaya Sompo Insurance Berhad.",
  },
  declaration: {
    declare1: `Saya/Kami telah membaca, memahami dan mengesahkan `,
    declare2: ` dan `,
    declare3: ` , dan dengan ini bersetuju untuk penggunaan dan pemprosesan data peribadi saya/kami oleh Kumpulan Syarikat Sompo dan Kumpulan Syarikat Berjaya (di dalam atau di luar Malaysia) untuk tujuan seperti yang dinyatakan dalam Notis Privasi.`,
    declare4: "Kami/Saya faham bahawa semua maklumat pendedahan produk akan disediakan dalam bentuk digital sahaja.",
    declaration: "Pengisytiharan",
    privacyNotice: "Notis Privasi",
    pds: " Lembaran Pendedahan Produk",
    tncAgree: "Sila bersetuju dengan terma sebelum meneruskan",
    yes: 'Ya',
    no: 'Tidak',
    concern: "Saya/Kami dengan ini memberikan kebenaran saya kepada Berjaya Sompo Insurance Berhad untuk berkongsi maklumat saya/kami (tidak termasuk maklumat yang berkaitan dengan hal ehwal atau akaun saya/kami) dengan CIMB Bank Berhad untuk tujuan pemasaran dan promosi mereka.",
    acknowledgement: "Pengakuan",
  },
  thankyouPage: {
    paymentSuccessful: "Pembayaran Berjaya",
    thankYouPayment: "Terima kasih kerana menginsuranskan kenderaan anda dengan Berjaya Sompo Insurance. Pembayaran anda telah berjaya disahkan.",
    transactionDetails: "Butiran Transaksi",
    orderNumber: "Nombor Pesanan",
    totalAmount: "Jumlah Keseluruhan",
    paymentMethod: "Kaedah Pembayaran",
    name: "Nama",
    policyNo: "No. Polisi",
    coveragePeriod: "Tempoh Perlindungan",
    coverageTo: " Hingga ",
    carRegNo: "Nombor Pendaftaran Kenderaan",
    makeSlashModel: "Buatan/Model",
    engineChassisNo: "Nombor Enjin/Casis",
    namedDriver: "Pemandu yang Dinamakan",
    anyDriver: "Mana-mana Pemandu Yang Dibenarkan",
    policyEmailPre: "Salinan resit dan Jadual Polisi anda akan dihantar ke alamat e-mel anda di",
    policyEmailPost: "Sila semak folder e-mel remeh atau spam anda sekiranya anda tidak menerima dokumen dalam peti masuk anda.",
    importantNotice: "Notis Penting",
    downloadpolicy: "Muat turun Polisi",
    notice_01: "Anda juga boleh memuat turun resit dan jadual polisi pada butang muat turun di atas. Sila ambil perhatian bahawa pautan butang muat turun akan tamat tempoh dalam masa 15 minit.",
    notice_02: "Untuk membuka fail, sila guna format kata laluan berikut: huruf pertama nama anda (seperti yang dinyatakan dalam polisi) dalam huruf besar, diikuti dengan 6 digit terakhir nombor Kad Pengenalan/Pasport anda.",
    notice_03: "Contohnya: Jika nama anda ialah John dan 6 digit NRIC terakhir ialah 141234, kata laluan anda ialah J141234.",
    cross_sell_travel: "/securemotor/images/cimb-img-cross-travel-bm.jpg",
    cross_sell_home: "/securemotor/images/cimb-img-cross-home-bm.jpg",
  },
  failPage: {
    paymentFailed: "Pembayaran Gagal",
    paymentFailedDesc: "Pembayaran anda tidak berjaya disahkan",
    paymentRetry: "Cuba Semula Pembayaran",
    orderNumber: "Nombor Pesanan",
    totalAmount: "Jumlah Keseluruhan",
    coveragePeriod: "Tempoh Perlindungan",
    makeSlashModel: "Buatan/Model",
    engineChassisNo: "Nombor Enjin/Casis",
    transactionDetails: "Butiran Transaksi",
    coverageTo: " Hingga ",
    carRegNo: "Nombor Pendaftaran Kenderaan",
  },
  contact_us: {
    title: "Perlukan Bantuan? Hubungi Kami",
    description: "Jika anda mempunyai sebarang pertanyaan, sila hubungi Pusat Khidmat Pelanggan Berjaya Sompo Insurance Berhad di talian +603 2170 7300 dari 8.30 pagi sehingga 5 petang (Isnin hingga Jumaat – tidak termasuk Cuti Umum) atau emel ke customer@bsompo.com.my. Sebagai alternatif, anda boleh menghubungi CIMB Bank Berhad di talian +603 6204 7788, yang tersedia 24 jam, atau e-mel contactus@cimb.com.",
    helpline_01: "Servis Kerosakan 24/7 untuk Kereta Persendirian",
    helpline_02: "Servis Kerosakan 24/7 untuk Motosikal",
    customer_01: "Berjaya Sompo Khidmat Pelanggan",
    customer_02: "8:30 AM - 5:00 PM (Isnin hingga Jumaat)",
    customer_03: "1 800 889 933 (Dalam Malaysia)",
    customer_04: "+603 2170 7300 (Luar Negara)",
    inMalaysia: "dalam Malaysia",
    oversea: "luar negara",
    registration_no: "No. Pendaftaran: 198001008821 (62605-U)"
  },
  form: {
    Private: "Persendirian",
    Business: "Perniagaan",
    EV: "Kereta EV"
  },
  simplequote: {
    vehno: "Nombor Pendaftaran Kenderaan",
    nric_passport: "No. KP/Passport",
    busregno: "Nombor Pendaftaran Perniagaan",
    fullname: "Nama Penuh",
    fullname2: "Nama Penuh (Seperti di dalam KP)",
    companyname: "Nama Syarikat",
    postcode: "Poskod (Lokasi Kenderaan)",
    email: "E-mel",
    marital_status: "Status Perkahwinan",
    occupation: "Perkerjaan",
    type_business: "Jenis Perniagaan",
    field_require: "Sila Isi Ruang Yang Berkenaan",
    name_short: "Nama terlalu pendek",
    valid_name: "Sila masukkan nama yang sah",
    invalid_postcode: "Poskod tidak sah",
    valid_vehno: "Sila masukkan nombor pendaftaran kenderaan yang sah",
    valid_email: "Sila masukkan e-mel yang sah",
    dropdown_selection: "Sila Pilih",
    submit_btn: "Dapatkan Sebut Harga Insurans Kereta",
    disclaimer_01: "Dengan menekan butang ‘Dapatkan Sebut Harga Insurans Kereta’, anda telah membaca dan bersetuju dengan ",
    disclaimer_02: "Notis Privasi",
    disclaimer_03: " kami.",
    companyNameShortError: "Nama Syarikat terlalu pendek",
    invalidFormat: "Format tidak sah",
  },
  whySOMPO: {
    title: "Mengapa Pilih Insurans Kereta Secure Motor?",
    desc: "Berikut adalah sedikit sebanyak maklumat tentang insurans kereta SecureMotor kami di Malaysia.",
    why1_title: "Perlindungan Untuk Semua Pemandu (Komplimentari)",
    why1_desc: "Perlindungan untuk semua pemandu, di mana tiada lebihan wajib dan pencalonan diperlukan.",
    why2_title: "Perlindungan Bencana Khas Tanpa Caj",
    why2_desc: "Memberi perlindungan sebarang kehilangan/kerosakan pada kereta anda disebabkan oleh banjir, ribut, tanah runtuh dan lain-lain, sehingga nilai 20% daripada jumlah diinsuranskan, tertakluk kepada had maksimum RM10,000.",
    // why2_title: "Perlindungan Peril Khas Penuh",
    // why2_desc: "Memberi perlindungan sebarang kehilangan/kerosakan pada kereta anda disebabkan oleh banjir, ribut, tanah runtuh dan banyak lagi.",
    why3_title: "Kelulusan Tuntutan Pantas Dalam Tempoh 24 Jam",
    why3_desc: "Nikmati kelulusan tuntutan dalam masa hanya 24 jam untuk jumlah tuntutan sehingga RM20,000. Panel Bengkel kami yang dipercayai akan menguruskan setiap langkah permohonan tuntutan anda tanpa sebarang bayaran pendahuluan daripada pihak anda.",
    // why3_title: "Jumlah Nilai Diinsuranskan Yang Dipersetujui",
    // why3_desc: "Pembayaran balik kepada anda nilai yang dipersetujui jika kenderaan anda rosak atau hilang.",
    why4_title: "Waranti Pembaikan 12 Bulan",
    why4_desc: "Waranti pembaikan selama 12 bulan terhadap kecacatan pada bahagian baru yang diganti dan mutu kerja yang dilaksanakan oleh bengkel panel kami.",
    why5_title: "Perkhidmatan Tunda Tanpa Had",
    why5_desc: "Komplimentari 24 Jam Khidmat Tunda Bagi Kerosakan & Kemalangan Tanpa Had.",
    why6_title: "Pelan Ansuran Faedah 0%",
    why6_desc: "Nikmati pelan ansuran tanpa faedah selama 6 bulan dengan premium dari RM480 dan 12 bulan dengan premium dari RM1,200 untuk kad kredit yang dikeluarkan oleh CIMB Kad Kredit (Conventional Kad Kredit sahaja).",
  },
  cross_sell: {
    title: "Meliputi setiap bahagian setiap hari",
    desc: "Ketahui lebih lanjut tentang produk insurans yang kami tawarkan",
    button_01: "Dapatkan Sebut Harga",
    button_02: "Dapatkan Sebut Harga",
    button_03: "Dapatkan Sebut Harga",
    travel_title: "Insurans Perjalanan",
    travel_01: "Perbelanjaan Perubatan, Hospital & Lain-lain sehingga RM 500,000.",
    travel_02: "Elaun Kuarantin Luar Negara Kerana COVID-19.",
    travel_03: "Evakuasi & Repatriasi Perubatan Kecemasan.",
    travel_04: "Kehilangan Deposit atau Pembatalan Penerbangan.",
    snatch_title: "Snatch Medz+",
    snatch_01: "Kematian Akibat Kemalangan sehingga RM600,000*.",
    snatch_02: "Indemniti Berganda akibat Ragut atau Rompakan sehingga RM1,200,000*.",
    snatch_03: "Perlindungan Pinjaman Kenderaan.",
    snatch_04: "Tiada Bonus Pembaharuan Tuntutan.",
    home_title: "Secure Home",
    home_01: "Premium Serendah RM11/Sebulan.",
    home_02: "Perlindungan Semua Risiko Termasuk Kebakaran, Banjir & Banyak Lagi.",
    home_03: "Pilihan Pelbagai Pelan dengan Perlindungan Sehingga RM60,000.",
    home_04: "Pengisytiharan Kandungan Rumah Tidak Diperlukan.",
  },
  disclaimer: {
    line_01: "Nota : Anda berada di laman web Berjaya Sompo Insurance Berhad, dasar privasi CIMB Group tidak terpakai.",
    line_02: "Penafian",
    line_03: "Deskripsi ciri dan manfaat yang dilampirkan pada produk insurans ini bukan kontrak insurans tetapi hanyalah ringkasan produk insurans bagi tujuan rujukan. Terma dan syarat lengkap produk insurans terkandung di dalam Dokumen Polisi Berjaya Sompo Insurance Berhad (No. Pendaftaran 198001008821 (62605-U)), Syarikat Insurans.",
    line_04: 'CIMB Bank Berhad ("Bank") tidak bertanggungjawab, bersetuju atau memegang liabiliti untuk produk insurans dan perkhidmatan yang diberikan oleh Syarikat Insurans.',
    line_05: "Pihak Bank hanya berfungsi sebagai pengedar untuk produk insurans ini.",
    line_06: "Produk insurans ini adalah hak milik Berjaya Sompo Insurance Berhad dan bukan produk kepunyaan pihak Bank. Bermaksud produk insurans ini tiada jaminan dari pihak Bank, syarikat subsidiari atau ahli gabungan dan Syarikat Insurans perlu sepenuhnya bertanggungjawab, bersetuju dan memegang liabiliti untuk produk insurans ini."
  },
  footer: {
    address: "Alamat",
    online_products: "Produk Dalam Talian",
    contact_us: "HUBUNGI KAMI",
    customer_service: {
      title: "Khidmat Pelanggan",
      line_01: "8:30 AM - 5:00 PM (Isnin hingga Jumaat)",
      line_02: "1 800 889 933 (dalam Malaysia)",
      line_03: "+603 2170 7300 (luar negara)",
      line_04: "Bantuan 24/7 Seluruh Dunia",
      line_05: "Servis Kerosakan 24/7 untuk Kereta Persendirian",
      line_06: "Servis Kerosakan 24/7 untuk Motosikal",
    },
    key_downloads: {
      title: "MUAT TURUN UTAMA",
      PDS: "Lembaran Pendedahan Produk",
      PW: "Susunan Kata Polisi",
      authorised_panel_workshops: "Bengkel Panel",
      TnC_instalment: "Terma dan Syarat (Pelan Pembayaran Ansuran 0%)",
      TnC_medical: "Terma dan Syarat (Kempen Pembaharuan Insurans Motor Dalam Talian)",
      rakan_auto: "Rakan Auto",
    },
    general_policy_terms: "Terma & Syarat Umum",
    privacy_notice: "Notis Privasi",
    legal_notice: "Notis Undang-undang",
    disclaimer: "Penafian",
    whistle_blowing_policy: "Polisi Pemberi Maklumat ",
    customer_servie_charter: "Customer Service Charter",
    PIDM_tips_brochure: "Brosur Sistem Perlindungan Manfaat Takaful dan Insurans PIDM",
    copyright: "Hak Cipta Terpelihara",
    registration_no: "No. Pendaftaran",
    PIDM: {
      line_01: "Manfaat-manfaat yang dibayar di bawah sijil/polisi/produk yang layak adalah dilindungi oleh PIDM sehingga had perlindungan. Sila rujuk",
      line_02: "Brosur Sistem Perlindungan Manfaat Takaful dan Insurans PIDM",
      line_03: "atau hubungi Berjaya Sompo Insurance Berhad atau PIDM (layari "
    },
    bnm_warning: "Sila maklum bahawa kami tidak akan sesekali meminta butiran peribadi anda secara dalam talian untuk mengakses sebarang maklumat produk yang terdapat di laman web kami. Kami menyeru semua pelanggan agar sentiasa berwaspada terhadap penipuan dalam talian."
  },
  errors: {
    errorOccured: "Ralat telah berlaku!",
    msg1: "Maaf, kami tidak dapat meneruskan permintaan anda secara dalam talian. Sila hubungi Khidmat Pelanggan kami di 1 800 889 933 atau +603 2170 7300, waktu operasi 8.30 pagi - 5.00 petang (Isnin hingga Jumaat) tidak termasuk cuti umum. Anda juga boleh menghantar butiran kenderaan anda (plat nombor dan No. KP) melalui e-mel ke customer@bsompo.com.my untuk mendapat bantuan lanjut.",
    msg: "Kami telah menerima permintaan anda dan akan menghubungi anda semula dalam tempoh 1-2 hari perniagaan. Jika anda tidak menerima sebarang balasan daripada kami, sila hantar e-mel kepada kami di customer@bsompo.com.my. Terima kasih.",
    msgEv1a: "Terima kasih kerana menghubungi kami. Pasukan kami sedang meneliti permohonan sebut harga anda dan akan memberikan maklum balas dalam tempoh",
    msgEv1b: "1-2 hari bekerja",
    msgEv2: "Sekiranya anda mempunyai sebarang pertanyaan atau tidak menerima sebarang balasan dalam tempoh tersebut, sila hubungi kami melalui saluran perhubungan yang disediakan di laman web kami.",
    msgEv3: "Kami menghargai kesabaran anda dan bersedia untuk membantu.",
    cxEmail: "customer@bsompo.com.my",
    vehicleRegistrationNo: "No. Pendaftaran Kenderaan",
    nricPassport: "No. KP / Pasport",
    email: "E-mel",
    fullName: "Nama Penuh (Seperti dalam KP)",
    contactNo: "Nombor dihubungi",
    CorrAddress: "Alamat",
    occupation: "Perkerjaan",
    requestManual: "Untuk memohon sebut harga secara manual, sila isi butiran di bawah.",
    successRequest: "Permohonan anda telah berjaya dihantar!",
    submit: "Serahkan",
    success: "Kejayaan"
  },
  campaign: {
    desc_01: "Dapatkan Perlindungan Banjir Sehingga",
    desc_02: " RM30,000 atau E-Baucar TNG RM40",
    desc_03: " Apabila Anda Menambah Perlindungan untuk Bencana Khas Penuh",
    desc_04: "Adakah anda perasan bahawa kejadian banjir kilat semakin kerap berlaku kebelakangan ini? Adakah anda sedar bahawa terdapat insiden pokok tumbang bersama ribut petir di sekitar anda? Adakah anda tahu bahawa kereta anda terdedah kepada bencana alam setiap hari?",
    desc_05: "Kini, anda boleh menikmati ketenangan apabila memilih untuk memperbaharui insurans kereta anda dengan Secure Motor. Anda boleh menikmati",
    desc_06: " perlindungan komplimentari sehingga RM30,000",
    desc_07: " untuk melindungi kereta anda daripada kehilangan atau kerosakan akibat bencana alam tanpa sebarang kos tambahan.",
    desc_08: "Jika anda rasa perlindungan komplimentari sehingga RM30,000 ini tidak mencukupi, anda boleh memilih untuk melindungi kereta anda dengan",
    desc_09: " perlindungan penuh terhadap bencana alam",
    desc_10: ". Anda juga layak menerima E-Baucar TNG bernilai",
    desc_11: " RM40",
    desc_12: " jika anda memilih perlindungan penuh terhadap bencana alam.",
    desc_13: " Tunggu apa lagi, beli Insurans Secure Motor sekarang dan nikmati faedah komplimentari atau E-Baucar TNG bernilai RM40. Kempen ini tamat pada 28 Februari 2025.",
    title: "Ganjaran Kempen: Komplimentari Perlindungan Bencana Alam atau Baucer TNG",
    date: "Tarikh Kempen: 01 September 2024 to 28 Februari 2025",
    remark: "Ikuti langkah mudah ini untuk menyertai kempen ini:",
    step_01: " Beli atau perbaharui Secure Motor secara dalam talian sepanjang tempoh kempen",
    step_02: " Setelah pembelian atau pembaharuan dalam talian selesai, anda akan secara automatik didaftarkan dalam kempen ini",
    product: "Produk",
    GWP: "Premium (GWP)",
    Campaign_Rewards: "Ganjaran Kempen",
    name: "Secure Motor (Dalam Talian)",
    no_min: "Tiada Premium Minimum",
    Rewards_res: "Komplimentari Perlindungan Bencana Alam sehingga RM30,000 jika anda tidak memilih untuk menambah perlindungan untuk Bencana Khas Penuh",
    Rewards_res2: "E-Baucar TNG RM40 percuma jika anda memilih untuk menambah perlindungan untuk Bencana Khas Penuh",
    tnc_btn: "Terma dan Syarat",
    tnc: "T&S dikenakan"
  },
  maritalstatus: {
    MARRIED: "BERKAHWIN",
    SINGLE: "BUJANG",
    DIVORCED: "BERCERAI",
    WIDOWED: "JANDA",
    OTHERS: "LAIN-LAIN",
  },
  back: "Kembali",
  next: "Seterusnya",
  selection: "Sila Pilih",
  contact_us2: {
    title: "Perlukan Bantuan? Hubungi Kami",
    description: "Jika anda mempunyai sebarang pertanyaan, sila hubungi Pusat Khidmat Pelanggan Berjaya Sompo Insurance Berhad di talian +603 2170 7300 dari 8.30 pagi sehingga 5 petang (Isnin hingga Jumaat – tidak termasuk Cuti Umum) atau emel ke customer@bsompo.com.my. Sebagai alternatif, anda boleh menghubungi CIMB Bank Berhad di talian +603 6204 7788, yang tersedia 24 jam, atau e-mel contactus@cimb.com ",
    helpline_01: "Servis Kerosakan 24/7 untuk Kereta Persendirian",
    helpline_02: "Servis Kerosakan 24/7 untuk Motosikal",
    customer_01: "Berjaya Sompo Khidmat Pelanggan",
    customer_02: "+603 2170 7300  (8:30 AM - 5:00 PM - Monday to Friday)",
    customer_03: "CIMB Customer Service",
    customer_04: "+603 6204 7788 (24 Hours)",
    twentyfourhours: "24 Hours",
    registration_no: "No. Pendaftaran: 198001008821 (62605-U)"
  },
  tinNotFound: "<strong>Notis:</strong> Kami tidak dapat mengesan Nombor Pengenalan Cukai (TIN) yang sah dikaitkan dengan maklumat anda. Oleh itu, e-Invois tidak akan dijana untuk transaksi ini. Jika anda memerlukan e-Invois, sila e-mel kepada kami di <a href='mailto:customer@bsompo.com.my'>customer@bsompo.com.my</a> selepas transaksi anda selesai.",
  consentModalTitle: "Perakuan dan Persetujuan",
  readAndAcknowledge_1: "Sila baca, fahami dan setuju dengan",
  readAndAcknowledge_2: "untuk meneruskan.",
  agree: "SETUJU"
}